// @flow
import * as React from 'react';
import type { Confirmation } from 'speed-js-react';
import { BackHandler, View } from 'react-native';
import MessageDialog from './MessageDialog';

type Props = {
    confirmations: Array<Confirmation>,
    onClose: (confirmation: Confirmation) => void,
    clearConfirmations: () => void,
}

const ConfirmationActionsRenderer = (props: Props) => {
    const { confirmations, onClose, clearConfirmations } = props;

    React.useEffect(() => {
        window.addEventListener('popstate', clearConfirmations);
        BackHandler.addEventListener('hardwareBackPress', clearConfirmations);
        return () => {
            window.removeEventListener('popstate', () => clearConfirmations);
            BackHandler.removeEventListener('hardwareBackPress', () => clearConfirmations);
        };
    }, [clearConfirmations]);
    
    return (
        <View>
            {
                confirmations.map((confirm) => {
                    const actions = [...confirm.actions];
                    actions.forEach((action) => {
                        const { callback } = action;
                        action.onClick = (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                            e.preventDefault();
                            callback(e);
                            onClose(confirm);
                        };
                    });

                    return (
                        <MessageDialog
                            key={confirm.message}
                            message={confirm.message}
                            actions={actions}
                        />
                    );
                })
            }
        </View>
    );
};

export default React.memo<Props>(ConfirmationActionsRenderer);
